import type { ActivityLogicPlugin } from '../../core/types/plugin.base.types';
import type { DataChartPayload, DataChartRuntime } from '../../core/types/payloads/data_chart.types';
import type { HostActionPayload, StudentInputEnvelope } from '../../core/types/events.types';
import type { RoutingMode } from '../../core/types/room.types';
import { DataChartPayloadSchema } from '../../core/schemas/examGenerationSchema';
import { coerceDataChartPayloadChartType } from './chartTypeNormalize';

export function validateDataChartPayload(raw: unknown): DataChartPayload {
  const coerced = coerceDataChartPayloadChartType(raw);
  const parsed = DataChartPayloadSchema.safeParse(coerced);
  if (!parsed.success) {
    const first = parsed.error.issues[0];
    throw new Error(first?.message || 'DataChart payload invalid');
  }

  const data = parsed.data;
  return {
    chartType: data.chartType,
    title: data.title.trim(),
    ...(data.instruction?.trim() ? { instruction: data.instruction.trim() } : {}),
    ...(data.blueprintPurpose?.trim() ? { blueprintPurpose: data.blueprintPurpose.trim() } : {}),
    ...(data.xAxisLabel?.trim() ? { xAxisLabel: data.xAxisLabel.trim() } : {}),
    ...(data.yAxisLabel?.trim() ? { yAxisLabel: data.yAxisLabel.trim() } : {}),
    ...(data.surveyChartTemplate ? { surveyChartTemplate: true } : {}),
    data: data.data.map((point) => ({
      label: point.label.trim(),
      value: point.value,
    })),
  };
}

export function createInitialDataChartRuntime(
  _payload: DataChartPayload,
  _routing: RoutingMode,
): DataChartRuntime {
  return { viewed: false };
}

export const dataChartLogic: ActivityLogicPlugin<'data_chart'> = {
  mode: 'data_chart',
  validatePayload: validateDataChartPayload,
  createInitialRuntime: createInitialDataChartRuntime,

  onStudentInput(ctx, input: StudentInputEnvelope) {
    if (input.action === 'EXAM_CONTINUE' || input.action === 'VIEW') {
      return { runtime: { ...ctx.runtime, viewed: true } };
    }
    return { runtime: ctx.runtime, rejected: true, rejectReason: 'UNKNOWN_ACTION' };
  },

  onHostAction(ctx, _action: HostActionPayload) {
    return { runtime: ctx.runtime };
  },
};

export function demoDataChartPayload(): DataChartPayload {
  return validateDataChartPayload({
    chartType: 'bar',
    title: 'Resultados de la encuesta',
    xAxisLabel: 'Opciones de respuesta',
    yAxisLabel: 'Cantidad de votos',
    surveyChartTemplate: true,
    data: [
      { label: '', value: 0 },
      { label: '', value: 0 },
      { label: '', value: 0 },
    ],
  });
}
